// src/data/workExperience.js

export const WORK_EXPERIENCE = [
  {
    company: 'A*STAR Genome Institute of Singapore (A*STAR GIS)',
    title: 'Student Attachment Programme Intern',
    period: 'Jun ’21 – Aug ’21',
    bullets: [
      'Researched neural network architectures for spatial omics data analysis',
      'Developed and benchmarked graph neural network variants using PyTorch Geometric and TensorFlow',
    ],
    logo: '/work_images/gis.png',
  },
  {
    company: 'Affinidi',
    title: 'Software Engineering Intern',
    period: 'May ’22 – Aug ’22',
    bullets: [
      'Worked in an Agile team to build a multi-tenant SaaS health wallet with SSI and Verifiable Credentials',
      'Optimized backend APIs in Node.js/TypeScript for credential data handling',
      'Developed dynamic React/TypeScript UI components for multiple credential types',
      'Wrote unit and integration tests for API endpoints using JUnit',
    ],
    logo: '/work_images/Affinidi.png',
  },
  {
    company: 'DXC Technology',
    title: 'College Intern, Software Engineering',
    period: 'Aug ’23 – Apr ’24',
    bullets: [
      'Leveraged Gunicorn worker processes to enable concurrency and background task execution in a Django application',
      'Developed Python scripts for automated file validation and implemented rate limiting on critical endpoints',
      'Performed extensive load testing with Apache JMeter.',
      'Integrated Swagger UI, enabling interactive API documentation',
    ],
    logo: '/work_images/dxc.png',
  },
  {
    company: 'Microtube Technologies (iHealthtech)',
    title: 'Research Engineer',
    period: 'Jul ’24 – Oct ’24',
    bullets: [
      'Developed an accessible on-screen keyboard for Muscular Dystrophy patients using Flutter',
      'Helped to develop a Unity-based situational training tool with multilingual dialog support',
    ],
    logo: '/work_images/ihealthtech.png',
  },
  {
    company: 'DXC Technology',
    title: 'Full-Stack Developer',
    period: 'Nov ’24 – Present',
    bullets: [
      'Contributing to the development of large-scale enterprise applications, including a national travel document system serving over 1 million monthly travellers and an insurance platform for MSIG, built with Angular and Spring Boot.',
    ],
    logo: '/work_images/dxc.png',
  },
];
